import * as React from "react";
import MarkdownIt from "markdown-it";
import MdEditor from "react-markdown-editor-lite";
import MarkdownItTexMath from "markdown-it-texmath";
import MarkDownItSup from "markdown-it-sup";
import MarkItContainer from "markdown-it-container"
import MarkItVideo from "@vrcd-community/markdown-it-video"

// import style manually
import "react-markdown-editor-lite/lib/index.css";
import './editor.css';

/**
 * @author
 * @function ReviewEditor
 **/

const ProjectPageEditor = ({
  textValue,
  setTextValue
}) => {

  async function initFlickity() {
    if (typeof window !== 'undefined') {
      const elems = document.querySelectorAll('.main-carousel');
      const Flickity = (await import('flickity')).default;
      elems.forEach((elem) => {new Flickity(elem, {
        lazyLoad: true,
        wrapAround: true,
        autoPlay: true,
        pageDots: false
      })})
    }
  }

  React.useState(initFlickity, []);

  const mdParser = new MarkdownIt({ html: true });
  mdParser.use(MarkdownItTexMath)
  mdParser.use(MarkDownItSup)
  mdParser.use(MarkItContainer, "author")
  mdParser.use(MarkItContainer, "institution")
  mdParser.use(MarkItContainer, "button")
  mdParser.use(MarkItContainer, "caption")

  mdParser.use(MarkItContainer, "carousel",
    {
      render: function (tokens, idx) {
        // var m = tokens[idx].info.trim().match(/^spoiler\s+(.*)$/);

        if (tokens[idx].nesting === 1) {
          // opening tag
          return `<div class="main-carousel" data-flickity='{ "cellAlign": "left", "contain": true }'>`;

        } else {
          // closing tag
          return '</div>\n';
        }
      }
    })

mdParser.use(MarkItContainer, "dark-mode",
    {
      render: function (tokens, idx) {

        if (tokens[idx].nesting === 1) {
          // opening tag
          return `  <div class="dark-mode-switch">
          <input id="dark-mode" type="checkbox" onclick="document.documentElement.classList.toggle('dark-mode')"> 
          <label for="dark-mode">Dark mode</label>`;

        } else {
          // closing tag
          return '</div>\n';
        }
      }
    })
  mdParser.use(MarkItContainer, "carousel-cell")
  mdParser.use(MarkItContainer, "carousel-caption")
  mdParser.use(MarkItVideo)


  // Finish!
  function handleEditorChange({ html, text }) {
    setTextValue(text);
    console.log(html);
    initFlickity();
  }

  return (
    <>
      <form className="editor-box">
        <MdEditor
          value={textValue}
          placeholder="Write a project page... (Markdown &#10003;)"
          renderHTML={(text) => mdParser.render(text)}
          onChange={handleEditorChange}
        />
      </form>
    </>
  );
};

export default ProjectPageEditor;
